import {
  BaSeButton,
  BaSeHeading6,
  BaSeParagraph,
  BaSeTheme,
} from '@base/react';
import React from 'react';
import { useMessage } from '../../../../../../hooks/messages/useMessage';
import { useUserService } from '../../../../../../hooks/services/user-service';
import { AlignButtonsLeft, Container } from './find-manager-by-name-style';

// import { Container } from './styles';

function ConfifmSelfInclude({ idInterview, confirmInclude, closeModal }) {
  const { gerInformationsManagerAuth } = useUserService();
  const { handleError } = useMessage();

  const [manager, setManager] = React.useState();

  React.useEffect(() => {
    gerInformationsManagerAuth()
      .then((response) => {
        setManager(response);
      })
      .catch(() => {
        setManager(undefined);
      });
  }, [gerInformationsManagerAuth]);

  return (
    <Container>
      <BaSeHeading6
        color={BaSeTheme.colors.feedbackInterface.atencao55}
        isBold={true}
      >
        Atenção!
      </BaSeHeading6>
      <BaSeParagraph>
        Tem certeza que deseja acompanhar o progresso desse candidato?
      </BaSeParagraph>

      <BaSeParagraph>
        Ao confirmar, você irá receber informações via e-mail sobre o processo
        seletivo do candidato ao Seminário.
      </BaSeParagraph>

      <AlignButtonsLeft>
        <BaSeButton
          value="Sim"
          color={BaSeTheme.colors.defaultColors.black}
          onClick={() => {
            if (manager === undefined) {
              handleError('Falha nas credenciais do gestor!');
              return;
            }
            const idMnagerResponsible = manager?.id;
            confirmInclude(idInterview, idMnagerResponsible, closeModal);
          }}
        />
        <BaSeButton value="Não" type="secondary" onClick={() => closeModal()} />
      </AlignButtonsLeft>
    </Container>
  );
}

export default ConfifmSelfInclude;
